module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "DOT.8f378c19.svg";